// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { cooInputsn } from "../../formSource";
// import { useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify"; // Import Toast functions
// import "react-toastify/dist/ReactToastify.css"; // Import CSS for toast

// const COONew = ({ title }) => {
//   const navigate = useNavigate();
//   const [inputValues, setInputValues] = useState({});
//   const [options, setOptions] = useState([]);
//   const [roptions, setRoptions] = useState([]);
//   const [selectedRoles, setSelectedRoles] = useState([
//     { value: "2", label: "COO" },
//   ]);

//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Please Login first, then you can access this page...");
//     window.location.href = "/"; // Redirect to login page
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleRoleSelectChange = (selectedOptions) => {
//     setSelectedRoles(selectedOptions);
//   };

//   const handleCenterSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       center_id: selectedOption.value,
//     });
//     // Filter out the selected center from the options list
//     setOptions((prevOptions) =>
//       prevOptions.filter((option) => option.value !== selectedOption.value)
//     );
//   };

//   useEffect(() => {
//     center_name();
//     roles();
//   }, []); // Run once on component mount

//   const roles = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/role_id`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch roles.");
//       }
//       const data = await response.json();
//       const roleList = data.data.map((role) => ({
//         value: role.id,
//         label: role.name,
//       }));
//       setRoptions(roleList);
//     } catch (error) {
//       toast.error("Error fetching roles.");
//     }
//   };

//   const center_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/center_id`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch centers.");
//       }
//       const data = await response.json();
//       const centerList = data.data.map((center) => ({
//         value: center.id,
//         label: center.name,
//       }));
//       setOptions(centerList);
//     } catch (error) {
//       toast.error("Error fetching centers.");
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const roleValues = selectedRoles.map((option) => option.value);
//     const formData = new FormData();
//     formData.append("center_id", inputValues.center_id);
//     formData.append("name", inputValues.name);
//     formData.append("email", inputValues.email);
//     formData.append("phone_no", inputValues.phone_no);
//     formData.append("password", inputValues.password);
//     formData.append("role_id", [roleValues]);

//     try {
//       const response = await fetch(`${serverUrl}/add_user`, {
//         method: "POST",
//         body: formData,
//       });

//       const data = await response.json();
//       console.log("Response from API", data);

//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });

//           // Re-fetch center options and restore the selected one
//           const updatedCenters = await fetch(`${serverUrl}/center_id`)
//             .then((res) => res.json())
//             .then((data) =>
//               data.data.map((center) => ({
//                 value: center.id,
//                 label: center.name,
//               }))
//             );
//           setOptions(updatedCenters);

//           // Restore selected center in dropdown (if still valid)
//           const selectedCenter = updatedCenters.find(
//             (c) => c.value === inputValues.center_id
//           );
//           if (!selectedCenter) {
//             // If center_id is no longer valid, remove it
//             setInputValues((prev) => {
//               const updated = { ...prev };
//               delete updated.center_id;
//               return updated;
//             });
//           }
//         } else {
//           toast.error(data.message || "An error occurred, please try again.");
//         }
//       } else {
//         toast.success(data.message || "COO has been added successfully!");
//         setTimeout(() => {
//           navigate(`/coo`);
//         }, 1000);
//       }

//       // Reset form after successful submission
//       setInputValues({});
//       setSelectedRoles([{ value: "2", label: "COO" }]); // Reset role to default
//     } catch (error) {
//       console.log("Error occurred while adding COO:", error);
//       toast.error("Error occurred while adding the COO!");
//     }
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   {cooInputsn.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "role_id" ? (
//                         <Select
//                           options={roptions}
//                           name={input.fieldName}
//                           isMulti
//                           value={selectedRoles}
//                           onChange={handleRoleSelectChange}
//                           isDisabled
//                           isClearable={false}
//                           required
//                         />
//                       ) : input.fieldName === "center_id" ? (
//                         <Select
//                           options={options}
//                           name={input.fieldName}
//                           onChange={handleCenterSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required={input.fieldName !== "status"}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Send
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer /> {/* ToastContainer to display notifications */}
//     </>
//   );
// };

// export default COONew;



import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { cooInputsn } from "../../formSource";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const COONew = ({ title }) => {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({});
  const [options, setOptions] = useState([]);
  const [roptions, setRoptions] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([
    { value: "2", label: "COO" },
  ]);

  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleRoleSelectChange = (selectedOptions) => {
    setSelectedRoles(selectedOptions);
  };

  const handleCenterSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      center_id: selectedOption.value,
    });
    setOptions((prevOptions) =>
      prevOptions.filter((option) => option.value !== selectedOption.value)
    );
  };

  useEffect(() => {
    center_name();
    roles();
  }, []);

  const roles = async () => {
    try {
      const response = await fetch(`${serverUrl}/role_id`);
      if (!response.ok) {
        throw new Error("Failed to fetch roles.");
      }
      const data = await response.json();
      const roleList = data.data.map((role) => ({
        value: role.id,
        label: role.name,
      }));
      setRoptions(roleList);
    } catch (error) {
      toast.error("Error fetching roles.");
    }
  };

  const center_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/center_id`);
      if (!response.ok) {
        throw new Error("Failed to fetch centers.");
      }
      const data = await response.json();
      const centerList = data.data.map((center) => ({
        value: center.id,
        label: center.name,
      }));
      setOptions(centerList);
    } catch (error) {
      toast.error("Error fetching centers.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const roleValues = selectedRoles.map((option) => option.value);
    const formData = new FormData();
    formData.append("center_id", inputValues.center_id);
    formData.append("name", inputValues.name);
    formData.append("email", inputValues.email);
    formData.append("phone_no", inputValues.phone_no);
    formData.append("password", inputValues.password);
    formData.append("role_id", [roleValues]);

    try {
      const response = await fetch(`${serverUrl}/add_user`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });

          const updatedCenters = await fetch(`${serverUrl}/center_id`)
            .then((res) => res.json())
            .then((data) =>
              data.data.map((center) => ({
                value: center.id,
                label: center.name,
              }))
            );
          setOptions(updatedCenters);

          const selectedCenter = updatedCenters.find(
            (c) => c.value === inputValues.center_id
          );
          if (!selectedCenter) {
            setInputValues((prev) => {
              const updated = { ...prev };
              delete updated.center_id;
              return updated;
            });
          }
        } else {
          toast.error(data.message || "An error occurred, please try again.");
        }
      } else {
        toast.success(data.message || "COO has been added successfully!");
        setTimeout(() => {
          navigate(`/coo`);
        }, 1000);
      }

      setInputValues({});
      setSelectedRoles([{ value: "2", label: "COO" }]);
    } catch (error) {
      console.log("Error occurred while adding COO:", error);
      toast.error("Error occurred while adding the COO!");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {cooInputsn.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "role_id" ? (
                              <Select
                                options={roptions}
                                name={input.fieldName}
                                isMulti
                                value={selectedRoles}
                                onChange={handleRoleSelectChange}
                                isDisabled
                                isClearable={false}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "center_id" ? (
                              <Select
                                options={options}
                                name={input.fieldName}
                                onChange={handleCenterSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required={input.fieldName !== "status"}
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/coo")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                      >
                        Create COO
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </ThemeProvider>
  );
};

export default COONew;